import React from 'react'
import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'

import DetailsTab from './DetailsTab'
import SummaryTab from './SummaryTab'
import { TabContentContainer, useEvent, useGlobalCopyStore, useScreenSize } from '../../common'

const CashflowContent: React.FC = () => {
  const { cashflow: customCopy } = useGlobalCopyStore()
  const { isDesktop } = useScreenSize()
  const { onEvent } = useEvent()

  const [value, setValue] = React.useState(0)

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  React.useEffect(() => {
    onEvent(value === 0 ? 'cash_flow_summary' : 'cash_flow_details')
  }, [value])

  return (
    <Box>
      <Tabs
        aria-label={customCopy.cashflow_summary_and_details}
        centered={true}
        onChange={handleChange}
        textColor="primary"
        value={value}
        variant="fullWidth"
      >
        <Tab
          aria-controls="cashflow-tabpanel-0"
          id="cashflow-tab-0"
          label={customCopy.summary}
          sx={{
            textTransform: 'none',
          }}
        />
        <Tab
          aria-controls="cashflow-tabpanel-1"
          id="cashflow-tab-1"
          label={customCopy.details}
          sx={{
            textTransform: 'none',
          }}
        />
      </Tabs>
      <Box sx={{ mb: 32 }} />
      <TabContentContainer index={0} name="cashflow" value={value}>
        <Box sx={{ m: isDesktop ? 48 : 16 }}>
          <SummaryTab />
        </Box>
      </TabContentContainer>
      <TabContentContainer index={1} name="cashflow" value={value}>
        <Box sx={{ m: isDesktop ? 48 : 16 }}>
          <DetailsTab />
        </Box>
      </TabContentContainer>
    </Box>
  )
}

export default observer(CashflowContent)
